<template>
  <div>
    <div v-for="(ht_data, index) in hall_ticket_data" :key="index" class="bulk-ticket">
      <!-- Header -->
      <v-row align="center" no-gutters class="bk-header">
        <v-col :cols="isMkd ? 2 : 3" :sm="isMkd ? 2 : 3" :md="isMkd ? 2 : 3" style="text-align: center;">
          <img class="bk-logo" :src="org_basic_data.school_logo" alt="logo" width="115" height="115" />
        </v-col>
        <v-col :cols="isMkd ? 8 : 9" :sm="isMkd ? 8 : 9" :md="isMkd ? 8 : 9" class="text-center"
          style="text-align: center; overflow: visible; height: auto;">
          <h3 class="bk-title">{{ org_basic_data.trust_name }}</h3>
          <h3 class="bk-title bk-school">{{ org_basic_data.school_name }}</h3>
          <h3 class="bk-title bk-school">Hall Ticket</h3>
        </v-col>
        <v-col v-if="isMkd && org_id != '4'" cols="2" sm="2" md="2" style="text-align: center;">
          <img class="bk-logo" :src="org_basic_data.trust_logo" alt="logo" width="100" height="100" />
        </v-col>
      </v-row>

      <v-row class="bk-text bk-student">
        <v-col cols="12" sm="8" md="8">
          <div>
            <b>Student PRN :
              <span class="bk-line" :class="{ 'bk-noline': isMkd }">{{ ht_data.prn }}</span>
            </b>
          </div>
          <div>
            <b>Student's Name :
              <span class="bk-line" :class="{ 'bk-noline': isMkd }">{{ ht_data.stud_name }}</span>
            </b>
          </div>
          <div>
            <b>Mother's Name :
              <span class="bk-line" :class="{ 'bk-noline': isMkd }">{{ ht_data.mother_full_name }}</span>
            </b>
          </div>
          <div>
            <b>Father's Name :
              <span class="bk-line" :class="{ 'bk-noline': isMkd }">{{ ht_data.father_full_name }}</span>
            </b>
          </div>
          <div>
            <b>Date of Birth :
              <span class="bk-line" :class="{ 'bk-noline': isMkd }">{{ ht_data.stud_dob }}</span>
            </b>
          </div>
        </v-col>
        <v-col align="right" style="max-width: none;">
          <div class="bk-photo">
            <img v-if="isValidPhoto(ht_data.profile_photo_path)" :src="ht_data.profile_photo_path" alt="" />
            <span v-else>Photo</span>
          </div>
        </v-col>
      </v-row>

   
      <v-row class="bk-text bk-meta">
        <v-col cols="12" sm="3" md="3"><b>Gender: {{ ht_data.gender }}</b></v-col>
        <v-col cols="12" sm="4" md="4"><b>Stream: {{ ht_data.stream }}</b></v-col>
        <v-col cols="12" sm="5" md="5"><b>Medium of Instruction: {{ ht_data.medium_of_instruction }}</b></v-col>
      </v-row>

   
      <v-row class="bk-text bk-meta">
        <v-col cols="12" sm="2" md="2"><b>Class: {{ ht_data.std }}</b></v-col>
        <v-col cols="12" sm="3" md="3"><b>Division: {{ ht_data.div }}</b></v-col>
        <v-col cols="12" sm="2" md="2"><b>Roll No.: {{ ht_data.rollno }}</b></v-col>
        <v-col cols="12" sm="5" md="5"><b>Examination: {{ ht_data.exam_name }}</b></v-col>
      </v-row>

     
      <div class="bk-text bk-subject-title"><b>Subject Details</b></div>
      <table class="bk-timetable bk-text">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>DAY / DATE</th>
            <th>TIME</th>
            <th>SUBJECT</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in sortedStudentExamPlan(ht_data.exam_plan_data)" :key="i">
            <td>{{ i + 1 }}</td>
            <td>{{ item.day }} <br class="bk-br" /> {{ item.date }}</td>
            <td>{{ item.from_time }} to <br class="bk-br" /> {{ item.to_time }}</td>
            <td>{{ item.subject }}</td>
          </tr>
        </tbody>
      </table>


      <div class="bk-text bk-instr-title"><b>Instructions to Student:</b></div>
      <ol class="bk-instr">
        <li v-for="(instruction, k) in splitInstructions" :key="k">{{ instruction }}</li>
      </ol>

      <v-row class="ht-text ht-sign">
        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img v-if="!isMkd && ht_data.student_sign && !ht_data.student_sign.includes('/null')"
              :src="ht_data.student_sign" class="signature-img" />
          </div>
          {{ isMkd ? 'Class Teacher Sign.' : 'Student Sign.' }}
        </v-col>

        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img v-if="ht_data.exam_in_charge_url && !ht_data.exam_in_charge_url.endsWith('/null')"
              :src="ht_data.exam_in_charge_url" class="signature-img" />
          </div>
          Exam In-charge
        </v-col>
        <v-col cols="12" sm="4" md="4" align="center">
          <div class="sign-area">
            <img  v-if="ht_data.principal_sign && !ht_data.principal_sign.endsWith('/null')"
              :src="ht_data.principal_sign" class="signature-img" />
          </div>
          Principal Sign &amp; Stamp
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; 

export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org_id: null,
    org_basic_data: [],
    hall_ticket_data: [],
    instructions_list: [],
  }),
  computed: {
    splitInstructions() {
      if (!this.instructions_list || !this.instructions_list.length) return [];
      return String(this.instructions_list[0].value || "")
        .split(". ")
        .map((item) => item.trim())
        .filter((item) => item)
        // remove trailing dots so we never get "uniform only.."
        .map((item) => item.replace(/\.+$/, "") + ".");
    },
    isMkd() {
      const name = (this.org_basic_data.school_name || "")
        .toUpperCase()
        .replace(/[\s.]/g, "");
      return name.startsWith("MKD");
    },
  },
  mounted() {
    this.hall_ticket_data =
      JSON.parse(localStorage.getItem("hall_ticket_data")) || [];
    this.org_basic_data =
      JSON.parse(localStorage.getItem("org_basic_data")) || [];
    this.org_id = localStorage.getItem("EPS-org-id");
    this.instructions_list =
      JSON.parse(localStorage.getItem("instructions_list")) || [];
  },
  methods: {
    sortedStudentExamPlan(examPlanData) {
      return (examPlanData || []).slice().sort((a, b) => {
        const dateA = new Date(this.formatDate(a.date, a.from_time));
        const dateB = new Date(this.formatDate(b.date, b.from_time));
        return dateA - dateB;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    isValidPhoto(path) {
      return path && !path.includes("null");
    },
    formatDate(date, time) {
      const [day, month, year] = date.split("/");
      const monthMap = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
        Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
      };
      const formattedMonth = monthMap[month];
      const formattedTime = this.convertTo24HourFormat(time);
      return `${year}-${formattedMonth}-${day}T${formattedTime}:00`;
    },
    convertTo24HourFormat(time) {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":");
      if (modifier === "PM" && hours !== "12") {
        hours = parseInt(hours, 10) + 12;
      } else if (modifier === "AM" && hours === "12") {
        hours = "00";
      }
      return `${hours}:${minutes}`;
    },
  },
};
</script>

<style>

.sign-area {
    height: 55px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 5px;
}

.signature-img {
    max-width: 120px;
    max-height: 50px;
    object-fit: contain;
}
.bulk-ticket {
  margin: 0 20% 24px 20%;
  background-color: white;
  padding: 20px;
  font-family: "Times New Roman", Times, serif;
}

.bulk-ticket .bk-title {
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.bulk-ticket .bk-school {
  color: #000087;
  white-space: nowrap; 
}

.bulk-ticket .bk-text {
  font-size: 20px;
}

.bulk-ticket .bk-meta .col {
  padding-top: 2px;
  padding-bottom: 2px;
}

.bulk-ticket .bk-line {
  display: inline-block;
  width: 70%;
  border-bottom: 1px solid black;
  vertical-align: bottom;
}

.bulk-ticket .bk-noline {
  border-bottom: none;
}

.bulk-ticket .bk-photo {
  height: 140px;
  width: 120px;
  margin-right: 30px;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.bulk-ticket .bk-photo img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.bulk-ticket .bk-subject-title {
  margin-top: 10px;
}

.bulk-ticket .bk-instr-title {
  margin-top: 14px;
}

.bulk-ticket .bk-instr {
  list-style: none;
  padding: 0;
  margin: 0 0 0 11px;
  padding-top: 10px;
  line-height: 110%;
  font-size: 18px;
}

.bulk-ticket .bk-instr li {
  margin-bottom: 10px;
}

.bulk-ticket .bk-sign {
  font-weight: bold;
  padding-top: 17px;
  padding-bottom: 10px;
}

.bk-timetable {
  border-collapse: collapse;
  width: 100%;
}

.bk-timetable td,
.bk-timetable th {
  border: 1px solid black;
  padding: 4px;
  text-align: center;
}

.bk-timetable td:first-child {
  width: 10%;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 8mm;
  }

  html,
  body {
    height: auto !important;
    min-height: 0 !important;
    background: #fff !important;
  }

  .v-navigation-drawer,
  .v-app-bar,
  .v-toolbar,
  .v-footer,
  .v-snackbar,
  header,
  footer,
  nav,
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .v-application,
  .v-application--wrap {
    min-height: 0 !important;
    height: auto !important;
    background: #fff !important;
  }

  .v-main,
  .v-content,
  .v-main__wrap,
  .v-content__wrap,
  .container,
  .container--fluid {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
  }

  .bulk-ticket {
    box-sizing: border-box !important;
    width: 100% !important;
    max-width: 100% !important;
    height: 279mm !important;
    margin: 0 !important;
    padding: 0 2mm !important;
    overflow: hidden;
    page-break-after: always;
    break-after: page;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .bulk-ticket:last-child {
    page-break-after: auto;
    break-after: auto;
  }

  .bulk-ticket .row {
    margin: 0 !important;
  }

  .bulk-ticket .col {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  .bulk-ticket .bk-text {
    font-size: 14px !important;
  }

  .bulk-ticket .bk-title {
    font-size: 14px !important;
    margin-bottom: 8px !important;
  }

  .bulk-ticket .bk-school {
    font-size: 16px !important;
    white-space: nowrap !important;
  }

  .bulk-ticket .bk-logo {
    width: 100px !important;
    height: 100px !important;
    margin-left: 0 !important;
  }

  .bulk-ticket .bk-header {
    margin-bottom: 10px !important;
  }

  .bulk-ticket .bk-student > .col:first-child > div {
    margin-bottom: 4px;
  }

  .bulk-ticket .bk-photo {
    height: 140px;
    width: 115px;
    margin-right: 10px;
  }

  .bulk-ticket .bk-meta .col {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }

  .bulk-ticket .bk-subject-title {
    margin-top: 14px;
    margin-bottom: 4px;
  }

  .bk-timetable td,
  .bk-timetable th {
    padding: 6px 4px !important;
    font-size: 14px !important;
  }

  .bk-timetable .bk-br {
    display: none;
  }

  .bk-timetable tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .bulk-ticket .bk-instr-title {
    margin-top: 12px;
  }

  .bulk-ticket .bk-instr {
    font-size: 12px !important;
    padding-top: 8px;
    line-height: 120%;
  }

  .bulk-ticket .bk-instr li {
    margin-bottom: 5px !important;
  }

  .bulk-ticket .bk-sign {
    padding-top: 35px;
    padding-bottom: 0;
  }
}
</style>